import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
    <path fill="none" fillRule="evenodd" stroke="#6A6A6A" strokeWidth="1.5" d="M1.05 6.743L6 1.793l4.95 4.95" />
  </svg>
);
